import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ControlValueAccessor } from '@angular/forms';
import { provideValueAccessor } from 'studio-components/shared/value-accessor.utils';
import type { Button } from '../../models/button.model';

@Component({
  selector: 'studio-button-group',
  templateUrl: './button-group.component.html',
  styleUrls: ['./button-group.component.scss'],
  providers: [provideValueAccessor(() => ButtonGroupComponent)],
})
export class ButtonGroupComponent implements ControlValueAccessor {
  @Input() public disabled: boolean;
  @Input() public buttons: Button[] = [];
  @Input() public selected: Button;
  @Output() public selectionChange = new EventEmitter<Button>();

  public selectOption(button: Button) {
    if (this.selected && this.selected.value === button.value) {
      return;
    }

    if (!this.disabled) {
      this.selected = button;
      this.onChange(button.value);
      this.selectionChange.emit(button);
    }
  }

  /**
   * REACTIVE FORMS INTEGRATION
   */
  public onChange = (_: any) => {};
  public onTouched = (_: any) => {};

  // writes a new value to the input.
  public writeValue(value: any): void {
    this.selected = this.buttons.find((button) => button.value === value);
  }

  // function called when the control's value changes in the UI.
  public registerOnChange(fn): void {
    this.onChange = fn;
  }

  // function is called by forms API on initialization
  // to update the form model on blur/on touched.
  public registerOnTouched(fn): void {
    this.onTouched = fn;
  }

  // set disabled state
  public setDisabledState(disabled: boolean): void {
    this.disabled = disabled;
  }
}
